"use strict";var e=require("@apollo/client"),r=e.gql`
  query GetCities(
    $coverageFilters: CoverageFilterCityInput
    $uncoveredFilters: UncoveredFiltersCityInput
  ) {
    getCities(
      coverageFilters: $coverageFilters
      uncoveredFilters: $uncoveredFilters
    ) {
      id
      name
      code
      timeZone
    }
  }
`,t=e.gql`
  query GetStates(
    $coverageFilters: CoverageFilterStateInput
    $uncoveredFilters: UncoveredFiltersStateInput
    $storeReferences: [String!]
  ) {
    getStates(
      coverageFilters: $coverageFilters
      uncoveredFilters: $uncoveredFilters
      storeReferences: $storeReferences
    ) {
      id
      active
      name
    }
  }
`,i=e.gql`
  query GetCities(
    $coverageFilters: CoverageFilterCityInput
    $uncoveredFilters: UncoveredFiltersCityInput
    $storeReferences: [String!]
  ) {
    getCities(
      coverageFilters: $coverageFilters
      uncoveredFilters: $uncoveredFilters
      storeReferences: $storeReferences
    ) {
      id
      name
      code
      timeZone
    }
  }
`;exports.a=t,exports.b=i,exports.g=r;